export default "__VITE_ASSET__eb009436__"